import React, { Component } from 'react';

import Sorter from './Sorter';
import Filters from './Filters';
import LoadMoreButton from './LoadMoreButton';
import GhostContainer from './GhostContainer';
import Cards from '../Trek/Cards';
import SearchCards from '../../screens/Trek/SearchCards';

export default class ThemesCardContainer extends Component {
  state = {
    placeHasThemes: true,
  };

  render() {
    const {
      themesArray,
      getPlaceThemesByCategories,
      openSlider,
      limit,
      page,
      categories,
      placeName,
      theme,
      // getPlaceThemes,
      isLastPage,
      searchTerm,
      getCardsBySearchTerm,
    } = this.props;
    const { placeHasThemes } = this.state;
    if (!placeHasThemes) return null;
    return (
      <section className="no-gutters" id={theme}>
        <section className="col-12">
          <div className="white-panel">
            <h2>
              {theme}
              <span>
                <Sorter theme={theme} />
              </span>
              {theme === 'sightings' && (
                <span>
                  <Filters
                    theme={theme}
                    getThemesByCategories={getPlaceThemesByCategories}
                    configs={{ limit, page, categories, searchTerm }}
                  />
                </span>
              )}
              {theme === 'sightings' && (
                <span className="sight-search">
                  <SearchCards
                    theme={theme}
                    configs={{ limit, page, categories, searchTerm }}
                    getCardsBySearchTerm={getCardsBySearchTerm}
                  />
                </span>
              )}
            </h2>
            <div className="row">
              <GhostContainer theme={theme}>
                {themesArray.map((themeObj, i) => {
                  return (
                    <div className="col-xl-3 col-md-4" key={`${themeObj.id}`}>
                      <Cards
                        cardData={themeObj}
                        theme={theme}
                        slideIndex={i}
                        openSlider={openSlider}
                        placeName={placeName}
                        isPlace={true}
                        patchInfo={{ placeName }}
                      />
                    </div>
                  );
                })}
              </GhostContainer>
            </div>
            {!isLastPage && <LoadMoreButton loadMore={this.onLoadMore} />}
          </div>
        </section>
      </section>
    );
  }

  onLoadMore = () => {
    const { limit, page, categories, searchTerm, getPlaceThemes } = this.props;
    return getPlaceThemes({ limit, page: page + 1, categories, searchTerm });
  };

  componentDidMount() {
    const { limit, page, themesArray, getPlaceThemes } = this.props;

    if (themesArray.length === 0)
      getPlaceThemes({ limit, page, categories: 'all' }).then(response => {
        if (page === 1 && !response.data) {
          this.setState({
            placeHasThemes: false,
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/screens/Places/ThemeCardContainer.jsx